module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/png/briefing_en-04451752e99296a23ad5abc1eb69921e.png";